// extracted by css-extract-rspack-plugin
export default {"iconSmall":"iconSmall__dgAuW","iconMedium":"iconMedium__uRKbJ"};